import { PipesModule } from "src/app/_pipes/pipes.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ItemCommunityComponent } from "./item-community.component";
import { IonicModule } from "@ionic/angular";
import { FormsModule } from "@angular/forms";
import { CommentModule } from "src/app/app/_component/comment/comment.module";
import { RouterModule } from "@angular/router";
import { Community } from "../community.model";
import { TranslateModule } from "@ngx-translate/core";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";
import { SharedDirectivesModule } from "src/app/_directives/shared-directives.module";

@NgModule({
  declarations: [ItemCommunityComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CommentModule,
    RouterModule,
    TranslateModule,
    LoadingStiModule,
    SharedDirectivesModule,
    PipesModule,
  ],
  exports: [ItemCommunityComponent],
  providers: [Community],
})
export class ItemCommunityModule {}
